import React from "react";

export const Dialog = ({
  open,
  onOpenChange,
  children,
  overlayClassName = "",
  contentClassName = "",
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onOpenChange(false);
    }
  };

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${overlayClassName}`}
      onClick={handleBackdropClick}
    >
      <div
        className={`w-full max-w-lg rounded-lg bg-white p-6 shadow-lg dark:bg-gray-800 ${contentClassName}`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the dialog
      >
        {children}
      </div>
    </div>
  );
};

export const DialogContent = ({ children }) => {
  return <div className="space-y-4">{children}</div>;
};

export const DialogHeader = ({ children }) => {
  return <div className="mb-4 border-b pb-2">{children}</div>;
};

export const DialogTitle = ({ children }) => {
  return (
    <h2 className="text-2xl font-semibold text-indigo-600 dark:text-indigo-400 text-center">
      {children}
    </h2>
  );
};
